
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown, ChevronUp, BarChart3, Activity, Users, FileText, ClipboardList } from 'lucide-react';

interface MobileMenuSectionProps {
  icon: React.ReactNode;
  label: string;
  color: string;
  onClose: () => void;
}

const MobileMenuSection = ({ icon, label, color, onClose }: MobileMenuSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const basePath = label.toLowerCase();

  return (
    <div className="px-2 mt-1">
      <button 
        className="w-full flex justify-between items-center px-3 py-2 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50"
        onClick={() => setIsOpen(!isOpen)}
      >
        <div className="flex items-center">
          {React.cloneElement(icon as React.ReactElement, { className: `mr-2 h-5 w-5 ${color}` })}
          <span className="text-sm font-medium">{label}</span>
        </div>
        {isOpen ? 
          <ChevronUp className="h-4 w-4" /> : 
          <ChevronDown className="h-4 w-4" />
        }
      </button>
      
      {isOpen && (
        <div className="ml-5 mt-1 space-y-1">
          <Link
            to={`/${basePath}/top-kpis`}
            className="flex items-center px-3 py-2 text-sm rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50"
            onClick={onClose}
          >
            <BarChart3 className="mr-2 h-4 w-4 text-gray-500" />
            <span>Top KPIs</span>
          </Link>
          <Link
            to={`/${basePath}/analytics`}
            className="flex items-center px-3 py-2 text-sm rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50"
            onClick={onClose}
          >
            <BarChart3 className="mr-2 h-4 w-4 text-gray-500" />
            <span>Analytics</span>
          </Link>
          <Link
            to={`/${basePath}/device-health`}
            className="flex items-center px-3 py-2 text-sm rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50"
            onClick={onClose}
          >
            <Activity className="mr-2 h-4 w-4 text-gray-500" />
            <span>Device Health</span>
          </Link>
          <Link
            to={`/${basePath}/consumers`}
            className="flex items-center px-3 py-2 text-sm rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50"
            onClick={onClose}
          >
            <Users className="mr-2 h-4 w-4 text-gray-500" />
            <span>Consumers</span>
          </Link>
          <Link
            to={`/${basePath}/bills`}
            className="flex items-center px-3 py-2 text-sm rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50"
            onClick={onClose}
          >
            <FileText className="mr-2 h-4 w-4 text-gray-500" />
            <span>Bills</span>
          </Link>
          <Link
            to={`/${basePath}/reports`}
            className="flex items-center px-3 py-2 text-sm rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800/50"
            onClick={onClose}
          >
            <ClipboardList className="mr-2 h-4 w-4 text-gray-500" />
            <span>Reports</span>
          </Link>
        </div>
      )}
    </div>
  );
};

export default MobileMenuSection;
